import { GET_PERMISSION, GET_TOKEN, SET_PERMISSION, SET_TOKEN } from "redux/TypeConstant"

const PermissionReducer=(state=JSON.parse(localStorage.getItem('Permission')),action)=>{
    switch(action.type)
    {
        case SET_PERMISSION:
        return state = action.data

        case GET_PERMISSION:
            return state 

            default :
            return state
    }

}

export default PermissionReducer